import type { IPublicationExtended } from '@typings/api/IPublication';
import type { IPublicationFilters } from '@typings/IPublicationFilters';

import { defaultFilters } from '../Index.const';

export interface IIndexItems {
    items: IPublicationExtended[];
    loading: boolean;
    filters: IPublicationFilters;
    countPublications: number;
    isAllLoaded: boolean;
}

/** Установка состояния после AJAX */
interface IIndexActionInit {
    type: 'init';
    count: number;
    items: IPublicationExtended[];
    filters: IPublicationFilters;
}

/** Подгрузка нового содержимого (вторая и последующие страницы) */
interface IIndexActionAppend {
    type: 'append';
    count: number;
    items: IPublicationExtended[];
}

/** Сброс фильтров */
interface IIndexActionResetFilters {
    type: 'resetFilters';
}

/** Проставление loading=true (например, для прогрузки последующей страницы) */
interface IIndexActionSetLoading {
    type: 'setLoading';
}

/** Очистка элементов и проставление loading=true */
interface IINdexActionClearItems {
    type: 'clearItems';
}

/** Замена всех элементов и loading=false */
interface IIndexActionReplace {
    type: 'replace';
    count: number;
    items: IPublicationExtended[];
}

/** Замена полей фильтров */
interface IIndexActionSetFilter<K extends keyof IPublicationFilters = keyof IPublicationFilters> {
    type: 'setFilter';
    key: K;
    value: IPublicationFilters[K];
}

export type IIndexAction =
    | IIndexActionInit
    | IIndexActionAppend
    | IIndexActionResetFilters
    | IIndexActionSetLoading
    | IINdexActionClearItems
    | IIndexActionReplace
    | IIndexActionSetFilter
;

export function itemsReducer(prev: IIndexItems, action: IIndexAction): IIndexItems {
    switch (action.type) {
        case 'init': {
            return {
                filters: action.filters,
                countPublications: action.count,
                items: action.items,
                isAllLoaded: action.items.length >= action.count,
                loading: false,
            };
        }

        case 'clearItems': {
            return {
                ...prev,
                items: [],
                loading: true,
                isAllLoaded: true,
            };
        }

        case 'resetFilters': {
            return {
                ...prev,
                filters: { ...defaultFilters },
            };
        }

        case 'setLoading': {
            return {
                ...prev,
                loading: true,
            };
        }

        case 'replace': {
            return {
                ...prev,
                items: action.items,
                countPublications: action.count,
                loading: false,
                isAllLoaded: action.items.length >= action.count,
            };
        }

        case 'append': {
            const items = prev.items.concat(action.items);

            return {
                ...prev,
                items,
                loading: false,
                isAllLoaded: items.length >= action.count,
            };
        }

        case 'setFilter': {
            return {
                ...prev,
                filters: {
                    ...prev.filters,
                    [action.key]: action.value,
                },
            };
        }
    }
}
